import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import { useDispatch } from "react-redux";
import { createAdminThunk } from "store/reducers/accounts";

function AdminAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    console.log(input);
    dispatch(createAdminThunk(input));
  };

  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Admin"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <AccountsCreateForm mod="Admin" callback={formCallback} />
        }
        listChildren={<ProfileView mod="admin" />}
      />
    </Box>
  );
}

export default AdminAccount;
